import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})

export class ApiService {
    constructor(private http: HttpClient, private translate: TranslateService) {}

    /**
     * @returns ID del idioma actual para back
     */
    public getLanguageId(): number {
        // aunque se coge del navegador porque al cargar la página hay un reseteo del defaultLang de la web
        const lang = this.translate.currentLang;

        // realmente solo tenemos traducciones para inglés americano
        if (lang.toLowerCase().includes('es')) {
            return 1;
        } else {
            return 2;
        }
    }

    public getCertificatePdf(filters: any): Observable<any> {
        return this.http.get<any>(
        	environment.apiEndpoint + `/CertificadoExpedicion/GeneraPDFCertificadoExpedicionByCSV?csv=${filters.csv}&idiomaId=${filters.idiomaID}`
		);
    }

    public getCertificateTraceability(filters: any): Observable<any> {
        return this.http.get<any>(
        	environment.apiEndpoint + `/CertificadoExpedicion/GetTrazabilidadCertificadoByNCertificadoExpedicion_Anonimo?nCertificadoExpedicion=${filters.num}&idiomaId=${filters.idiomaID}`
		);
    }
}
